<template>
  <div class="cld-product-card grid-item">
    <a :href="product.url" target="_blank">
    <div v-if="this.$store.state.config.product_card.includes('image')" v-bind:class="{alone: alone}">
      <img
       :src='(product.thumbnail_url || product.picture_url)'
       ref="product_image"
      >
      <img
        :src='product.alternate[0]'
        class="alternate"
        v-if='false && product.alternate && product.alternate[0]'
      >
      <div v-if="likeDislike && this.$store.state.config.product_card.includes('like-dislike') && product.name" class="cld-actions-container">
        <i
          class="cld-actions material-icons"
          :class="{'inverted' : liked}"
          :title='$t("notation.like")'
          @mouseup.stop
          @touchend.stop
          @click.stop.prevent='like'
        >
          thumb_up_alt
        </i>
        <i
          class="cld-actions material-icons"
          :class="{'inverted' : disliked}"
          :title='$t("notation.dislike")'
          @mouseup.stop
          @touchend.stop
          @click.stop.prevent='dislike'
        >
          thumb_down_alt
        </i>
        <template v-if="this.$store.state.config.product_card.includes('wishlist')">
        <i
          class="cld-actions material-icons"
          :class="{'inverted' : bookmarked}"
          :title='$t("notation.love")'
          @mouseup.stop
          @click.stop.prevent='bookmark'
        >
          favorite_border
        </i>
        </template>
      </div>
    </div>

    <div class="cld-product-details">
      <template v-if="showIndex" >
        <span class="cld-brand">{{index + 1}}. </span>
      </template>
      <template  v-if="brand && this.$store.state.config.product_card.includes('brand') && product.brand">
      <span class="cld-brand">{{product.brand}}</span>
      <br>
      </template>
      <span v-if="name && this.$store.state.config.product_card.includes('name') && product.name" class="cld-name">{{product.name}}</span>
      <br>
      <span v-if="price && this.$store.state.config.product_card.includes('price') && product.price" class="cld-price">
        <strike
          v-if='product.price_old'
          style="color:#555"
        >
        </strike>
        <template v-if='this.$store.state.config.storeId == 41'>
          {{ `USD ${product.price}` }}
        </template> 
        <template v-else-if='this.$store.state.config.storeId == 78'>
          {{ `${product.price} ${product.currency}` }}
        </template>
        <template v-else>
          {{ `${product.price} €` }}
        </template>
      </span>


      <!-- Similar Search Link -->
      <!-- /!\ === INACTIVE === /!\ -->
      <div
        class="" style="text-align:center; text-decoration:underline;"
        v-if="false && !product.is_similarity_result"
      >
        <a
          href="#" class="cld-name"
          @click.stop.prevent='similar'
        >
          Produits Similaires
        </a>
      </div>
      <!-- End Similar Search Link -->


    </div>
    </a>
  </div>
</template>

<script>
import { customLogger } from "@/utils";
import utils from '../utils'

  export default {
    name:'product-card',
    data () {
      return {
        liked: false,
        disliked: false,
        bookmarked: false,
        lookingForSimilar: false // For similarity search
      }
    },
    props: {
      showIndex: {
        type: Boolean,
        default: false
      },
      index: {
        type: Number,
        default: 0
      },
      product: {
        type: Object,
        default: () => {}
      },
      "like-dislike": {
          type: Boolean,
          default: true
      },
      brand: {
          type: Boolean,
          default: true
      },
      name: {
          type: Boolean,
          default: true
      },
      price: {
          type: Boolean,
          default: true
      },
      alone: {
          type: Boolean,
          default: false
      }
    },
    mounted() {

      if (this.$refs.product_image.complete) {
        utils.scrollDown()
      } else {
        this.$refs.product_image.addEventListener('load', utils.scrollDown)
        this.$refs.product_image.addEventListener('error', () => customLogger('error when loading image'))
      }

      if (this.product.price)
        this.product.price = this.formatPrice(this.product.price);
      if (this.product.price_old)
        this.product.price_old = this.formatPrice(this.product.price_old);
    },
    methods: {
       formatPrice(price) {
         //remove currency symbol
         price = price.replace(/[^0-9\.-]+/g,"");
        // Convert the price to a floating-point number
        const parsedPrice = parseFloat(price);

        // Check if the parsed price is a valid number
        if (isNaN(parsedPrice)) {
            return 'Invalid price';
        }

        // Format the price with two decimal places
        const formattedPrice = parsedPrice.toFixed(2);

        // Remove trailing zeros after the decimal point
        const finalPrice = formattedPrice.replace(/\.?0+$/, '');

        return finalPrice;
      },
      like (e) {
        this.liked=!this.liked
        this.liked && this.disliked ? this.dislike(e) : null;
        this.$eb.emit("BoxProductLike", this.product, this.liked)
      },
      dislike (e) {
        this.disliked=!this.disliked
        this.liked && this.disliked ? this.like(e) : null;
        this.$eb.emit("BoxProductDislike", this.product, this.disliked)
      },
      bookmark (e) {
        this.bookmarked=!this.bookmarked
        $eb.emit("BoxProductBookmark")
      },
      similar (e) { // Looking for similar products
        this.lookingForSimilar = !this.lookingForSimilar
        this.$eb.emit(
                    "BoxLookingForSimilar",
                    this.product,                 // Produt to lookup
                    this.$store.getters.store_id, // Store id
                    3,                            // Count
                    0                             // Shift
                  )
      }
    }
  };

</script>
